module.exports = __webpack_public_path__ + "img/chat-diagram.7f1c8191.png";